import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form, AgreementsAutocomplete } from "@shared/components";
import { useListIntegrationsQuery } from "@modules/erpIntegrations/services/queries";

export const ConfigListFilters = React.memo(() => {
  const translate = useTranslate();
  const { data: integrations = [] } = useListIntegrationsQuery({ perPage: 100 });

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate(
            "v1/agreement_integration_config_admin.filters.agreement"
          )}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="integration"
          label={translate(
            "v1/agreement_integration_config_admin.filters.integration"
          )}
          options={integrations.map((item) => ({
            value: item.id,
            label: item.name,
          }))}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="plan_map_option"
          label={translate(
            "v1/agreement_integration_config_admin.filters.plan_map_option"
          )}
          options={integrations.flatMap((item) =>
            (item.plan_map_options ?? []).map((option) => ({
              value: option.id,
              label: `${item.name} — ${option.label}`,
            }))
          )}
        />
      </Grid>
    </Grid>
  );
});
